import type {
  ExperimentConfig,
  PaidRoundupExperimentConfig,
  ReviewExperimentConfig,
  RoundupExperimentConfig,
} from './types';

export const STATIC_EXPERIMENTS: (
  | ExperimentConfig
  | RoundupExperimentConfig
  | PaidRoundupExperimentConfig
  | ReviewExperimentConfig
)[] = [
  // Commented out because of Best of Awards Experiment
  // {
  //   pageType: 'roundup',
  //   slugs: LAZY_LOAD_ROUNDUPS_EXPERIMENT_SLUGS,
  //   name: LAZY_LOAD_ROUNDUPS_EXPERIMENT_NAME,
  // },
];
